import React from 'react';
import { Box } from '@mui/material';

import { Button, Page } from 'components';
import { downloadBlob } from 'core/shared';
import { useTranslations } from 'hooks/useTranslations';

import { UseQuery } from 'useQuery';

function CustomPage() {
  const [fetch, setFetch] = React.useState(false);
  const translations = useTranslations('customPage');

  const { data: ijmondExportBlob, isLoading: loadingIjmondExport } =
    UseQuery.customIjmondReports(fetch);

  React.useEffect(() => {
    if (ijmondExportBlob) {
      downloadBlob({
        blob: ijmondExportBlob as unknown as Blob,
        fileName: 'ijmondBereikbaar_export',
      });

      setFetch(false);
    }
  }, [ijmondExportBlob]);

  return (
    <Page name={'custom'}>
      <Box>
        <Button
          svgName={'fileDownload'}
          label={translations.ijmondBereikbaarExport}
          onClick={() => setFetch(true)}
          loading={loadingIjmondExport}
          disabled={loadingIjmondExport}
        />
      </Box>
    </Page>
  );
}

export { CustomPage };
